import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { DocumentsData } from '@/features/ui/DocumentsData';
import { buildDocumentPreviewRows } from '@/features/ui/DocumentsData/model/preview';

import { FormSelect, Grid, StepControlPanel } from '@/shared/ui';

import { YesNoSelectOptions } from '@/components/Forms/constants';

import { useERZDocumentTypes } from '@/modules/erz/helpers';

import { DocumentTypeCode } from '@/api/types';

import { ContractSecurityActivitySchema } from '../../model/types';

export const ContractSecurityActivity: React.FC<StepProps> = ({ currentRequestId, prev, next, onStepDraftSave }) => {
  const { control, setValue, watch } = useFormContext<ContractSecurityActivitySchema>();
  const confirmTechnicalConditionDoc = watch('confirmContractSecurityActivityDoc');

  const { data: documentTypeEntities = [] } = useERZDocumentTypes({
    allowedDocumentTypeCodes: [DocumentTypeCode.CONTRACT_SECURITY_ACTIVITIES],
  });

  const safeRequestId = currentRequestId ?? '';

  useEffect(() => {
    if (!confirmTechnicalConditionDoc) {
      setValue('confirmContractSecurityActivityDoc', YesNoSelectOptions.NO);
    }
  }, []);

  return (
    <>
      <FormBlock title="Дані про договір із суб'єктом охоронної діяльності або поліцією охорони">
        <FormSelect
          name="confirmContractSecurityActivityDoc"
          label="Ви хочете додати дані документу?"
          options={Object.values(YesNoSelectOptions)}
          control={control}
          onChange={() => {
            setValue('contractSecurityActivity', null);
          }}
        />
        {Boolean(Number(confirmTechnicalConditionDoc?.id)) && (
          <DocumentsData
            withUploader
            documentTypeSelectDisabled
            documentTypeEntities={documentTypeEntities ?? []}
            maxDocumentsCount={1}
            name="contractSecurityActivity"
            request_id={safeRequestId}
            onSaveDraft={onStepDraftSave}
            documentsRequired
          />
        )}
      </FormBlock>
      <StepControlPanel prev={prev} next={next} />
    </>
  );
};

export const ContractSecurityActivityPreview: React.FC = () => {
  const { getValues } = useFormContext<ContractSecurityActivitySchema>();
  const { contractSecurityActivity, confirmContractSecurityActivityDoc } = getValues();
  const doc = Array.isArray(contractSecurityActivity) ? contractSecurityActivity[0] : undefined;
  const rows = buildDocumentPreviewRows(doc, "Дані про договір із суб'єктом охоронної діяльності або поліцією охорони");

  return Boolean(Number(confirmContractSecurityActivityDoc?.id)) ? (
    <Grid title="Дані про договір із суб'єктом охоронної діяльності або поліцією охорони" data={rows} />
  ) : null;
};
